import FJGenerateStatus from '../../../common/components/FJGenerateStatus/FJGenerateStatus';
import PropTypes from 'prop-types';
import styles from './FJMobileGenerateStatus.module.less';
import FJUtil from '../../../util/FJUtil';
import classNames from 'classnames';
import FJConstant from '../../../constants/FJConstant';

const FJMobileGenerateStatus = props => {
    const { taskStatus, onCancel, progress, currentQueue, queueNumber } = props;
    const isShow = FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.SUCCESS;

    return (
        <div className={classNames(styles.box, isShow ? styles.show : '')}>
            <FJGenerateStatus
                taskStatus={taskStatus}
                onCancel={onCancel}
                progress={progress}
                currentQueue={currentQueue}
                queueNumber={queueNumber}
                position={'middle'}
            />
        </div>
    );
};
FJMobileGenerateStatus.propTypes = {
    taskStatus: PropTypes.string,
    onCancel: PropTypes.func,
    progress: PropTypes.number,
    currentQueue: PropTypes.number,
    queueNumber: PropTypes.number,
};
export default FJMobileGenerateStatus;
